import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  GetEmployeesForOverrideInput,
  GetEmployeesForOverrideVariables,
  GetEmployeesForOverrideQueryResponse,
} from '../types';

const getEmployeesForOverrideQuery = gql`
  query GetEmployeesForOverride($input: GetEmployeesForOverrideInput!) {
    payrollGetEmployeesForOverride(input: $input) {
      code
      success
      message
      employee_ids
      pagination {
        page
        page_size
        total_count
        has_next
      }
    }
  }
`;

export const getEmployeesForOverride = (
  input: GetEmployeesForOverrideInput,
): Promise<GetEmployeesForOverrideQueryResponse> => {
  return graphQLApi<GetEmployeesForOverrideQueryResponse, GetEmployeesForOverrideVariables>({
    query: getEmployeesForOverrideQuery,
    queryVariables: {
      input,
    },
  });
};

